import { createModule } from '../createModule';
import { ICompany } from '@/models';

export const company = createModule<ICompany>('company');